export const preferenceGroups = {
  coordinateSystem: 'coordinateSystem',
  measurementSystem: 'measurementSystem',
  distanceUnitsMetric: 'distanceUnitsMetric',
  areaUnitsMetric: 'areaUnitsMetric',
  distanceUnitsUSC: 'distanceUnitsUSC',
  areaUnitsUSC: 'areaUnitsUSC',
} as const;

export const coordinateSystems = {
  dd: 'decimal-degrees',
  dms: 'degrees-minutes-seconds',
  mgrs: 'military-grid-reference-system',
} as const;
